// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Recharts = require("recharts");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var AxisData$ReactHooksTemplate = require("./axisData.res.js");
var Recharts$ReactHooksTemplate = require("../common/Recharts.res.js");
var DataWindow$ReactHooksTemplate = require("./dataWindow.res.js");
var ChartComponentColor$ReactHooksTemplate = require("./chartComponentColor.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");

function ComposedChartComponent(props) {
  var chartHeight = props.chartHeight;
  var enlarged = props.enlarged;
  var onClick = props.onClick;
  var drillDownKey = props.drillDownKey;
  var chartAttribute = props.chartAttribute;
  var chartId = props.chartId;
  var renderToolTip = function (data) {
    var payload = data["payload"];
    if (payload == null) {
      return JsxRuntime.jsx("div", {});
    }
    var newPayload = Js_dict.values(payload);
    var match = newPayload.length;
    if (match === 0) {
      return JsxRuntime.jsx("div", {});
    }
    console.log(Caml_array.get(newPayload, 0));
    var payloadData = Js_dict.get(Caml_array.get(newPayload, 0), "payload");
    if (payloadData !== undefined) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("ul", {
                        children: Belt_Array.map(Js_dict.entries(payloadData), (function (param) {
                                return JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: String(param[0])
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: " : "
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: param[1]
                                                  })
                                            ],
                                            className: "recharts-tooltip-item py-3-px"
                                          });
                              })),
                        className: "recharts-tooltip-itemlist"
                      }),
                  className: "recharts-default-tooltip bg-white border border-solid border-1\n            border-gray-300 p-2 w-64 max-w-full text-sm"
                });
    } else {
      return JsxRuntime.jsx("div", {});
    }
  };
  var renderLegend = function (value, param) {
    return JsxRuntime.jsx("span", {
                children: value,
                className: "text-xs"
              });
  };
  var enableCartesianGrid = GenericChartAttribute$ReactHooksTemplate.enableCartesianGrid(chartAttribute);
  var showTick = GenericChartAttribute$ReactHooksTemplate.showTick(chartAttribute);
  var xs = GenericChartAttribute$ReactHooksTemplate.yAxisList(chartAttribute);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Recharts.ResponsiveContainer, {
                    children: JsxRuntime.jsxs(Recharts.ComposedChart, {
                          data: GenericChartAttribute$ReactHooksTemplate.data(chartAttribute),
                          margin: Caml_option.some(Recharts$ReactHooksTemplate.Margin.make(20, 10, 0, 10)),
                          children: [
                            enableCartesianGrid !== undefined && !enableCartesianGrid ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(Recharts.CartesianGrid, {}),
                            JsxRuntime.jsx(Recharts.XAxis, {
                                  minTickGap: enlarged ? 4 : 2,
                                  dataKey: AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)),
                                  tick: Caml_option.some(showTick !== undefined && !showTick ? Recharts$ReactHooksTemplate.Tick.make(0, undefined, undefined)(undefined, undefined, undefined) : Recharts$ReactHooksTemplate.Tick.make(10, 0, undefined)("middle", 10, undefined)),
                                  interval: 0,
                                  height: chartHeight === "h-96" ? 100 : 90,
                                  tickMargin: 10,
                                  tickFormatter: (function (key) {
                                      return Js_array.joinWith(" ", Js_string.split("-", Js_array.joinWith(" ", Js_string.split("_", key))));
                                    })
                                }),
                            (console.log(GenericChartAttribute$ReactHooksTemplate.yAxisList(chartAttribute)), JsxRuntime.jsx(JsxRuntime.Fragment, {})),
                            GenericChartAttribute$ReactHooksTemplate.enableDataWindow(chartAttribute) ? DataWindow$ReactHooksTemplate.show(chartAttribute, enlarged, props.containerWidth) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                            xs ? $$Array.of_list(Belt_List.map(xs, (function (x) {
                                          var x$1 = AxisData$ReactHooksTemplate.yAxisOrientation(x);
                                          var textAnchor;
                                          if (x$1 !== undefined) {
                                            switch (x$1) {
                                              case "left" :
                                                  textAnchor = "end";
                                                  break;
                                              case "right" :
                                                  textAnchor = "start";
                                                  break;
                                              default:
                                                textAnchor = undefined;
                                            }
                                          } else {
                                            textAnchor = undefined;
                                          }
                                          var match = [
                                            AxisData$ReactHooksTemplate.min(x),
                                            AxisData$ReactHooksTemplate.max(x)
                                          ];
                                          var domain;
                                          if (match.length !== 2) {
                                            domain = undefined;
                                          } else {
                                            var min = match[0];
                                            if (min !== undefined) {
                                              var max = match[1];
                                              domain = max !== undefined ? [
                                                  min,
                                                  max
                                                ] : undefined;
                                            } else {
                                              domain = undefined;
                                            }
                                          }
                                          var id = AxisData$ReactHooksTemplate.yAxisId(x);
                                          var y = AxisData$ReactHooksTemplate.yAxisOrientation(x);
                                          return JsxRuntime.jsx(Recharts.YAxis, {
                                                      yAxisId: id !== undefined ? id : "left",
                                                      tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, undefined, undefined)(textAnchor, 10, true)),
                                                      orientation: y === "right" ? "right" : "left",
                                                      domain: domain,
                                                      type: "number",
                                                      hide: AxisData$ReactHooksTemplate.hideYAxis(x)
                                                    });
                                        }))) : $$Array.of_list({
                                    hd: JsxRuntime.jsx(Recharts.YAxis, {
                                          yAxisId: "left",
                                          tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, undefined, undefined)("end", 10, true)),
                                          orientation: "left"
                                        }),
                                    tl: /* [] */0
                                  }),
                            JsxRuntime.jsx(Recharts.Tooltip, {
                                  content: renderToolTip
                                }),
                            JsxRuntime.jsx(Recharts.Legend, {
                                  formatter: renderLegend
                                }),
                            $$Array.of_list(Belt_List.mapWithIndex(GenericChartAttribute$ReactHooksTemplate.yAxis(chartAttribute), (function (i, xs) {
                                        var stackId = AxisData$ReactHooksTemplate.stackId(xs);
                                        var match = AxisData$ReactHooksTemplate.type_(xs);
                                        switch (match) {
                                          case "Line" :
                                              var color = AxisData$ReactHooksTemplate.fill(xs);
                                              var match$1 = AxisData$ReactHooksTemplate.key(xs);
                                              var tmp = match$1 === "KPI" ? "3 4 5 2" : "";
                                              var y = AxisData$ReactHooksTemplate.yAxisId(xs);
                                              var match$2 = AxisData$ReactHooksTemplate.key(xs);
                                              var tmp$1;
                                              if (match$2 === "KPI") {
                                                tmp$1 = JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                              } else {
                                                var enableCartesianGrid = GenericChartAttribute$ReactHooksTemplate.enableLabel(chartAttribute);
                                                tmp$1 = enableCartesianGrid !== undefined && !enableCartesianGrid ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(Recharts.LabelList, {
                                                        dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                        position: "top",
                                                        fill: "black",
                                                        fontSize: 12
                                                      });
                                              }
                                              return JsxRuntime.jsx(Recharts.Line, {
                                                          type: "monotone",
                                                          dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                          stroke: color !== undefined ? color : ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute)),
                                                          strokeDasharray: tmp,
                                                          connectNulls: true,
                                                          yAxisId: y !== undefined ? y : "left",
                                                          children: Caml_option.some(tmp$1)
                                                        }, String(i));
                                          case "Bar" :
                                              var color$1 = AxisData$ReactHooksTemplate.fill(xs);
                                              var y$1 = AxisData$ReactHooksTemplate.yAxisId(xs);
                                              var json = GenericChartAttribute$ReactHooksTemplate.data(chartAttribute);
                                              return JsxRuntime.jsx(Recharts.Bar, {
                                                          dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                          barSize: 30,
                                                          fill: color$1 !== undefined ? color$1 : ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute)),
                                                          stackId: stackId,
                                                          yAxisId: y$1 !== undefined ? y$1 : "left",
                                                          onClick: (function (data, param) {
                                                              var key = Json_decode.field(AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)), Json_decode.string, Belt_Option.getExn((data == null) ? undefined : Caml_option.some(data)).payload);
                                                              Curry._3(onClick, key, chartId, GenericChartAttribute$ReactHooksTemplate.onClick(chartAttribute));
                                                            }),
                                                          children: Caml_option.some(json !== undefined ? Belt_Array.map(Belt_Option.getWithDefault(Js_json.decodeArray(json), []), (function (x) {
                                                                        var tmp;
                                                                        if (drillDownKey !== undefined) {
                                                                          if (Caml_obj.equal(Js_json.decodeString(Belt_Option.getWithDefault(Js_dict.get(Belt_Option.getWithDefault(Js_json.decodeObject(x), {}), AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute))), null)), String(drillDownKey))) {
                                                                            var color = AxisData$ReactHooksTemplate.fill(xs);
                                                                            tmp = color !== undefined ? color : ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute));
                                                                          } else {
                                                                            tmp = "#d8d8d8";
                                                                          }
                                                                        } else {
                                                                          var color$1 = AxisData$ReactHooksTemplate.fill(xs);
                                                                          tmp = color$1 !== undefined ? color$1 : ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute));
                                                                        }
                                                                        return JsxRuntime.jsx(Recharts.Cell, {
                                                                                    fill: tmp
                                                                                  }, String(chartId));
                                                                      })) : JsxRuntime.jsx(JsxRuntime.Fragment, {}))
                                                        }, String(i));
                                          case "Scatter" :
                                              var color$2 = AxisData$ReactHooksTemplate.fill(xs);
                                              var y$2 = AxisData$ReactHooksTemplate.yAxisId(xs);
                                              var enableCartesianGrid$1 = GenericChartAttribute$ReactHooksTemplate.enableLabel(chartAttribute);
                                              return JsxRuntime.jsx(Recharts.Scatter, {
                                                          dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                          fill: color$2 !== undefined ? color$2 : ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute)),
                                                          yAxisId: y$2 !== undefined ? y$2 : "left",
                                                          children: Caml_option.some(enableCartesianGrid$1 !== undefined && !enableCartesianGrid$1 ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(Recharts.LabelList, {
                                                                      dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                                      position: "top",
                                                                      fill: "black",
                                                                      fontSize: 12
                                                                    }))
                                                        }, String(i));
                                          
                                        }
                                      })))
                          ]
                        })
                  }),
              className: " w-full " + chartHeight + " p-20-px "
            });
}

var make = ComposedChartComponent;

exports.make = make;
/* recharts Not a pure module */
